import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const authLocalstorageStr = sessionStorage.getItem('authLocalstorage');
  
  // If there's no auth data in session storage, redirect to the login page
  if (!authLocalstorageStr) {
    return <Navigate to="/" replace />;
  }
  
  try {
    const authLocalstorage = JSON.parse(authLocalstorageStr);
    
    // If there's no token in the auth data, redirect to the login page
    if (!authLocalstorage || !authLocalstorage.token) {
      return <Navigate to="/" replace />;
    }
    
    // Check if user has client role
    const userRole = authLocalstorage.role;
    const userRoles = authLocalstorage.roles || [];
    const user = authLocalstorage.user || {};
    
    // Check if user has client role (par nom ou dans le tableau roles)
    const isClient = userRoles.includes('client') || 
                    userRoles.some(r => r.toLowerCase() === 'client') ||
                    user?.role?.name?.toLowerCase() === 'client';
    
    // Vérifier aussi que l'utilisateur a un client_id
    if (isClient && !user.client_id) {
      sessionStorage.removeItem('authLocalstorage');
      return <Navigate to="/" replace />;
    }
    
    if (!isClient) {
      // User doesn't have client role, redirect to login
      sessionStorage.removeItem('authLocalstorage');
      return <Navigate to="/" replace />;
    }

    // If authorized, render the children
    return children;
  } catch (error) {
    console.error('❌ Error parsing authentication data:', error);
    // If there's an error parsing the auth data, redirect to the login page
    sessionStorage.removeItem('authLocalstorage');
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;
